export default __webpack_public_path__ + "static/media/telegram-icon.ce087de1.svg";